import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Checkbox, Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'

import { FBSFundMoveTranInfo, FBSCCYInfo } from '../Types'
import { SystemHeader, FBSClientPicker, FBSCCYSuggest } from '../CommonUI';
import { Pagination, PageInfo } from '../CommonUI';

import i18next from 'i18next';


var GsbFlag: any;

var UserID: string;
var PgmCode = "FT0004" ;
var isReqAuth2:boolean = false ;

interface FBSFundMoveTranEntryViewProps {
    gsb: AxiosInstance,
    FundMoveTran: FBSFundMoveTranInfo,
    FundMoveTran0: FBSFundMoveTranInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
}


export function FBSFundMoveTranEntryView({ gsb, FundMoveTran = {} as FBSFundMoveTranInfo, FundMoveTran0 = {} as FBSFundMoveTranInfo,baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2}: FBSFundMoveTranEntryViewProps) {


    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    const [AuthUser, setAuthUser] = useState("")
    const [password, setPassword] = useState("")

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
/*
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
*/

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, FundMoveTran])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_Seq" in FundMoveTran)) return null


    return (
        <div>
            {/* define add,change,delete button */}
            { ViewMode === "V" && <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }
                <Button className="Col-9-2" icon="document" onClick={() => { window.open(`/#/ClientPosEnquiry?acCode=${FundMoveTran.d_Acct}`, '_blank') } } >Balance & Portfolio</Button>
            </div> }
            { ViewMode === "L" && <div>
                Seq No. : {FundMoveTran.d_Seq}
                { (logKey2.indexOf("*A1") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Amend</div> }
                { (logKey2.indexOf("*C") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Create</div> }
                { (logKey2.indexOf("*D") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Delete</div> }
                { ! (FundMoveTran0.d_AuthId.toString() == "") && <div id="DispText2">Auth : {utils.dispDate(FundMoveTran0.d_AuthDate, "3")} {FundMoveTran0.d_AuthTime} User {FundMoveTran0.d_AuthId} </div> }
                <div className="Spacing-V-16" />
            </div> }

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Seq No.">
                    <InputGroup readOnly value={FundMoveTran.d_Seq} />
                </FormGroup>
                <FormGroup className="Col-5-1" label="Input User">
                    <InputGroup readOnly value={FundMoveTran.d_Userid} />
                </FormGroup>
                <FormGroup className="Col-6-1" label="Action">
                    <InputGroup readOnly value={FundMoveTran.d_Action} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account No." labelInfo="*">
                    <InputGroup readOnly value={FundMoveTran.d_Acct} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (FundMoveTran0.d_Acct.toString() == "") && 
                    <div id="DispText2" > {FundMoveTran0.d_Acct} </div> }
                </FormGroup>
                <FormGroup className="Col-2-3" label="Account Name">
                    <div id="DispText">{FundMoveTran.d_acName1}</div>
                    <div id="DispText">{FundMoveTran.d_acName2}</div>
                </FormGroup>
                <FormGroup className="Col-5-2" label="Tran Date">
                    <InputGroup readOnly value= {utils.dispDate(FundMoveTran.d_Date, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (FundMoveTran0.d_Date.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(FundMoveTran0.d_Date, GsbFlag.dateFormat)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Type D/W" labelInfo="*">
                    <InputGroup readOnly value={utils.fbsDepositWithdrawTypeName(FundMoveTran.d_Type)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (FundMoveTran0.d_Type.toString() == "") && 
                    <div id="DispText2" > {FundMoveTran0.d_Type} </div> }
                </FormGroup>
                <FormGroup className="Col-2-1" label="Currency" labelInfo="*">
                    <InputGroup readOnly value={FundMoveTran.d_Curcy} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (FundMoveTran0.d_Curcy.toString() == "") && 
                    <div id="DispText2" > {FundMoveTran0.d_Curcy} </div> }
                </FormGroup>
                <FormGroup className="Col-3-1" label="Amount" labelInfo="*">
                    <InputGroup readOnly type='number' value={utils.numToString(FundMoveTran.d_Amt)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (FundMoveTran0.d_Amt.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(FundMoveTran0.d_Amt)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Bank A/C#">
                    <InputGroup readOnly value={FundMoveTran.d_Bank} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (FundMoveTran0.d_Bank.toString() == "") && 
                    <div id="DispText2" > {FundMoveTran0.d_Bank} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Description">
                    <InputGroup readOnly value={FundMoveTran.d_Descrip} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (FundMoveTran0.d_Descrip.toString() == "") && 
                    <div id="DispText2" > {FundMoveTran0.d_Descrip} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Cheque #">
                    <InputGroup readOnly value={FundMoveTran.d_Cheque} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (FundMoveTran0.d_Cheque.toString() == "") && 
                    <div id="DispText2" > {FundMoveTran0.d_Cheque} </div> }
                </FormGroup>
            </div>
        </div>
    )
}

interface FBSFundMoveTranEntryEditProps {
    gsb: AxiosInstance,
    ccyList: FBSCCYInfo[],
    FundMoveTran?: FBSFundMoveTranInfo,
    isNew?: boolean,
    onSave?: (stk: FBSFundMoveTranInfo) => void,
    onCancel?: () => void,
}

export function FBSFundMoveTranEntryEdit({ gsb, ccyList, FundMoveTran = {} as FBSFundMoveTranInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: FBSFundMoveTranEntryEditProps) {

    const { register, handleSubmit, reset, getValues, setValue, setError, errors } = useForm<FBSFundMoveTranInfo>()

    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [AcCodeValue, setAcCodeValue] = useState(FundMoveTran.d_Acct)
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)
    const [AcName1Value, setAcName1Value] = useState(FundMoveTran.d_acName1)
    const [AcName2Value, setAcName2Value] = useState(FundMoveTran.d_acName2)

    const [CCYValue, setCCYValue] = useState(ccyList.find((ccyInfo) => ccyInfo.d_Curcy === ("d_Curcy" in FundMoveTran ? FundMoveTran.d_Curcy : "HKD")))

    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastEdit UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])

    useEffect(() => {
        // Call reset to get the values of record FundMoveTranInfo 
        if ("d_Seq" in FundMoveTran) {
            reset(FundMoveTran)
        }
    }, [FundMoveTran, reset])


    useEffect(() => {
        // Some components (e.g. Suggest) don't have ref to use with react-hook-form, so register the fields manually and call setValue when item is selected
        // register({ name: "d_FieldName" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    useEffect(() => {
        (async () => {
            try {
                // get AC Info
                const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "CLMast", cAction: "GetCLInfo", cAcct: AcCodeValue})
                
                if ( AcCodeValue.trim().length > 0 && res.data.count > 0 )
                {
                    setAcName1Value(res.data.data[0].d_Name)
                    setAcName2Value(res.data.data[0].d_Name2)
                    // setCommCodeValue(res.data.data[0].d_CommCode)
                } else { 
                    setAcName1Value("")
                    setAcName2Value("")
                    // setCommCodeValue("")
                }
            
            } catch (error) {
                //showErrorBox(error)
            }
        })()

    }, [gsb, AcCodeValue])

    const fillDefaultDesc = () => {
        if (getValues("d_Descrip") === "") {
            let desc = ""
            let type = getValues("d_Type")
            switch (type) {
                case "D":
                    desc = "FUND DEPOSIT"
                    break
                case "W":
                    desc = "FUND WITHDRAW"
                    break
            }
            setValue("d_Descrip", desc)
        }
    }

    if (! isNew && ! ("d_Seq" in FundMoveTran)) return null

    let acNoLength = 12 // FBS standard A/C length
    
    const onSubmit = (data: FBSFundMoveTranInfo) => {
        // put value to json/field before write database dbf
        data.d_Curcy = CCYValue?.d_Curcy || "";

        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }

        (async () => {
            try {
                const res = await gsb.post('/fbs/Transaction', {sb_data: data, cPgmId: "FundMoveTranEntry", cAction: "FundMoveTranValidate", isNew: isNew})

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    return (
        <form onKeyDown={handleHotkey}>
            <FBSClientPicker gsb={gsb} isOpen={isClPickerOpen} onClose={()=>setIsClPickerOpen(false)} onSelect={(ac)=>{setAcCodeValue(ac.d_Acct); setIsClPickerOpen(false)}}/>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Seq No." labelFor="inputSeqNo">
                    <InputGroup className="inputNumberNoSpin" disabled={true} id="inputSeqNo" name="d_Seq" defaultValue="" placeholder='Auto-generated' inputRef={register} />
                    {errors.d_Seq && errors.d_Seq.type === "required" && (<span id="Err_msg">Seq No. cannot be Blank</span>)}
                    {errors.d_Seq && errors.d_Seq.types && <span id="Err_msg">{errors.d_Seq.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-5-1" label="Input User" labelFor="inputInputUser">
                    <InputGroup disabled={true} id="inputInputUser" name="d_Userid" defaultValue="" placeholder="Input User ..." inputRef={register({ maxLength: 10}) } />
                    {errors.d_Userid && errors.d_Userid.type === "maxLength" && <span id="Err_msg">Max length is 10</span>}
                    {errors.d_Userid && errors.d_Userid.types && <span id="Err_msg">{errors.d_Userid.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-6-1" label="Action" labelFor="inputAction">
                    <InputGroup disabled={true} id="inputAction" name="d_Action" defaultValue="" placeholder="Action ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_Action && errors.d_Action.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_Action && errors.d_Action.types && <span id="Err_msg">{errors.d_Action.types.message}</span>}
                </FormGroup>
             </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account No." labelFor="inputacCode" labelInfo="*">
                    <InputGroup id="inputacCode" name="d_Acct" value={AcCodeValue} autoFocus placeholder="Account No. ..." onChange={utils.handleStringChange(s => setAcCodeValue(s.toUpperCase()))} inputRef={register({ required: true , maxLength: acNoLength}) } 
                        rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setIsClPickerOpen(true)}}></Button>}
                    />
                    {errors.d_Acct && errors.d_Acct.type === "required" && <span id="Err_msg">Account No. cannot be Blank</span>}
                    {errors.d_Acct && errors.d_Acct.type === "maxLength" && <span id="Err_msg">Max length is {acNoLength}</span>}
                    {errors.d_Acct && errors.d_Acct.types && <span id="Err_msg">{errors.d_Acct.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-3" label="Account Name">
                    <div>
                    <div id="DispText">{AcName1Value}</div>
                    <div id="DispText">{AcName2Value}</div>
                    </div>
                </FormGroup>
                <FormGroup className="Col-5-2" label="Tran Date" labelFor="d_Date">
                    <InputGroup disabled={true} id="d_Date" name="d_Date" defaultValue="" type="date" placeholder="Tran Date ..." inputRef={register} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Type D/W" labelFor="d_Type" labelInfo="*">
                    <HTMLSelect id="d_Type" fill
                        name="d_Type"
                        elementRef={register}
                    >
                        <option value="D">{utils.fbsDepositWithdrawTypeName("D")}</option>
                        <option value="W">{utils.fbsDepositWithdrawTypeName("W")}</option>
                    </HTMLSelect>
                </FormGroup>
                <FormGroup className="Col-2-1" label="Currency" labelFor="d_Curcy" labelInfo="*">
                    <FBSCCYSuggest items={ccyList} selectedItem={CCYValue} onItemSelect={(ccyInfo) => { setCCYValue(ccyInfo) }}></FBSCCYSuggest>
                    {/* <InputGroup id="d_Curcy" name="d_Curcy" defaultValue="" placeholder="Currency ..." onChange={utils.handleStringChange(s => setValue("d_Curcy", s.toUpperCase()))} inputRef={register({ required: true , maxLength: 3}) } />
                    {errors.d_Curcy && errors.d_Curcy.type === "required" && <span id="Err_msg">Currency cannot be Blank</span>}
                    {errors.d_Curcy && errors.d_Curcy.type === "maxLength" && <span id="Err_msg">Max length is 3</span>} */}
                    {errors.d_Curcy && errors.d_Curcy.types && <span id="Err_msg">{errors.d_Curcy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Amount" labelFor="d_Amt">
                    <InputGroup id="d_Amt" name="d_Amt" defaultValue={"0"} type="number" inputRef={register} onBlur={() => {fillDefaultDesc()}} />
                    {errors.d_Amt && errors.d_Amt.types && <span id="Err_msg">{errors.d_Amt.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Bank A/C#" labelFor="d_Bank">
                    <InputGroup id="d_Bank" name="d_Bank" defaultValue="" placeholder="Bank A/C# ..." inputRef={register({ maxLength: 12}) } />
                    {errors.d_Bank && errors.d_Bank.type === "maxLength" && <span id="Err_msg">Max length is 3</span>}
                    {errors.d_Bank && errors.d_Bank.types && <span id="Err_msg">{errors.d_Bank.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Description" labelFor="d_Descrip">
                    <InputGroup id="d_Descrip" name="d_Descrip" defaultValue="" placeholder="Description ..." inputRef={register({ maxLength: 50}) } />
                    {errors.d_Descrip && errors.d_Descrip.type === "maxLength" && <span id="Err_msg">Max length is 50</span>}
                    {errors.d_Descrip && errors.d_Descrip.types && <span id="Err_msg">{errors.d_Descrip.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Cheque #" labelFor="d_Cheque">
                    <InputGroup id="d_Cheque" name="d_Cheque" defaultValue="" placeholder="Cheque # ..." inputRef={register({ maxLength: 12}) } />
                    {errors.d_Cheque && errors.d_Cheque.type === "maxLength" && <span id="Err_msg">Max length is 3</span>}
                    {errors.d_Cheque && errors.d_Cheque.types && <span id="Err_msg">{errors.d_Cheque.types.message}</span>}
                </FormGroup>
            </div>
        </form>
    )
}

interface FBSFundMoveTranEntryMainProps {
    gsb: AxiosInstance
}

// const toaster = Toaster.create({
//     position: Position.TOP,
// })

function FBSFundMoveTranEntryMain({ gsb }: FBSFundMoveTranEntryMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { StkNo: defaultSearchValue = "" }: { StkNo: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as FBSFundMoveTranInfo[])

    const [searchKey, setSearchKey] = useState("SeqNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)
    const [searchAcName, setSearchAcName] = useState("")
    const [searchComdy, setSearchComdy] = useState("")
    
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentFundMoveTran, setcurrentFundMoveTran] = useState({} as FBSFundMoveTranInfo)
    const [CurrentLog1, setCurrentLog1] = useState({} as FBSFundMoveTranInfo)
    const [CurrentLog0, setCurrentLog0] = useState({} as FBSFundMoveTranInfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    const [ccyList, setCcyList] = useState([] as FBSCCYInfo[])

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                UserID = res.data.Flag.UserID
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "CCYMast",
                        cAction: "ListRec",
                    });
                setCcyList(res.data.data)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])

    useEffect(() => {

        if (logviewonly === "Y") {
            setViewMode("L")
        }
        //console.log("ClMastMain ViewMode: ", ViewMode)

        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 ) {
                    const res = await gsb.post('/fbs/Transaction', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "FundMoveTranEntry", 
                        cAction: "ViewLogRec"
                    })
                    //console.log("FBSClMastMain ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog0(res.data.data[0])
                        setCurrentLog1(res.data.data[1])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])


    const PrevRecProcess = async (FundMoveTran: FBSFundMoveTranInfo) => {
        try {
            const res = await gsb.post('/fbs/Transaction', {sb_data: FundMoveTran, cPgmId: "FundMoveTranEntry", cAction: "PrevRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Seq === res.data.data.d_Seq) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentFundMoveTran(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (FundMoveTran: FBSFundMoveTranInfo) => {
        try {
            FundMoveTran.d_AuthTran = ""
            if (isReqAuth2) {
                FundMoveTran.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/fbs/Transaction', {sb_data: FundMoveTran, cPgmId: "FundMoveTranEntry", cAction: "DelRec"})
            if (isReqAuth2) {
                utils.showSuccess("Seq No. " + FundMoveTran.d_Seq + " record deleting, waiting for authorization")
            } else {
                utils.showSuccess("Seq No. " + FundMoveTran.d_Seq + " record deleted")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Seq === res.data.data.d_Seq) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setcurrentFundMoveTran(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                utils.showSuccess("Seq No. " + FundMoveTran.d_Seq + " record deleting, waiting for authorization")
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (FundMoveTran: FBSFundMoveTranInfo) => {
        try {
            //console.log("call NextRecProcess", FundMoveTran)
            const res = await gsb.post('/fbs/Transaction', {sb_data: FundMoveTran, cPgmId: "FundMoveTranEntry", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Seq === res.data.data.d_Seq) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentFundMoveTran(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (FundMoveTran: FBSFundMoveTranInfo) => {
        try {
            //console.log("call newOnSave", FundMoveTran)
            const res = await gsb.post('/fbs/Transaction', {sb_data: FundMoveTran, cPgmId: "FundMoveTranEntry", cAction: "AddRec"})
            //showSuccess("Seq No. " + FundMoveTran.d_Seq + " record added")
            if (isReqAuth2) {
                utils.showSuccess("Seq No. " + res.data.data.d_Seq + " record adding, waiting for authorization")
            } else {
                utils.showSuccess("Seq No. " + res.data.data.d_Seq + " record added")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Seq === res.data.data.d_Seq) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setcurrentFundMoveTran(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                setShowAlert1Msg("Seq No. " + res.data.data.d_Seq + " record adding, waiting for authorization")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (FundMoveTran: FBSFundMoveTranInfo) => {
        try {
            //console.log("call editOnSave", FundMoveTran)
            const res = await gsb.post('/fbs/Transaction', {sb_data: FundMoveTran, cPgmId: "FundMoveTranEntry", cAction: "UpdateRec"})
            if (isReqAuth2) {
                utils.showSuccess("Seq No. " + FundMoveTran.d_Seq + " record saving, waiting for authorization")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Seq === res.data.data.d_Seq) {
                        setcurrentFundMoveTran(data[i])
                        break
                    }
                }
                setCurrentMode("show")
                setisShowAlert1(true)
                setShowAlert1Msg("Seq No. " + FundMoveTran.d_Seq + " record saving, waiting for authorization")
            } else {
                utils.showSuccess("Seq No. " + FundMoveTran.d_Seq + " record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Seq === res.data.data.d_Seq) {
                        data[i] = { ...data[i], ...res.data.data }
                        //console.log("editOnSave data", i, data)
                        setData(data)
                        break
                    }
                }
                //console.log("editOnSave res.data.data", res.data.data)
                setcurrentFundMoveTran(res.data.data)
                setCurrentMode("show")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        try {
            //console.log("FundMoveTranEntryMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/fbs/Transaction',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            acName: searchAcName,
                            comdy: searchComdy,
                        }, 
                    },
                    cPgmId: "FundMoveTranEntry",
                    cAction: "ListRec",
                });

                //console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentFundMoveTran(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/fbs/Transaction',
                {   sb_data: {
                        d_Seq: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "FundMoveTranEntry",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setcurrentFundMoveTran(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("FundMoveTranEntryMain useEffect length > 0  called", data)
                const res = await gsb.post('/fbs/Transaction',
                    {   sb_data: {
                            by: "SeqNo",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "FundMoveTranEntry",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentFundMoveTran(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    const res = await gsb.post('/fbs/Transaction',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                acName: searchAcName,
                                comdy: searchComdy,
                            }, 
                        },
                        cPgmId: "FundMoveTranEntry",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setcurrentFundMoveTran(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    // currentMode = show
    let detail = <FBSFundMoveTranEntryView gsb={gsb} FundMoveTran={currentFundMoveTran} FundMoveTran0={currentFundMoveTran} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentFundMoveTran)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentFundMoveTran)} onNextRec={() => NextRecProcess(currentFundMoveTran)} ViewMode={ViewMode} logKey2={logKey2.trim()}></FBSFundMoveTranEntryView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <FBSFundMoveTranEntryEdit gsb={gsb} ccyList={ccyList} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></FBSFundMoveTranEntryEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <FBSFundMoveTranEntryEdit gsb={gsb} ccyList={ccyList} FundMoveTran={currentFundMoveTran} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></FBSFundMoveTranEntryEdit>
            break
        }

    let logKeyViewRec = <FBSFundMoveTranEntryView gsb={gsb} FundMoveTran={CurrentLog1} FundMoveTran0={CurrentLog0} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentFundMoveTran)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentFundMoveTran)} onNextRec={() => NextRecProcess(currentFundMoveTran)} ViewMode={ViewMode} logKey2={logKey2.trim()}></FBSFundMoveTranEntryView>

    let pagination = <Pagination nPage={nPage} nTotalPage={nTotalPage} aPageNumber={aPageNumber} setnPage={(n)=>setnPage(n)}></Pagination>
    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-120">Seq No</th>
                <th className="TCol-120">Account No.</th>
                <th className="TCol-300">Name</th>
                <th className="TCol-100">Type</th>
                <th className="TCol-100">CCY</th>
                <th className="TCol-100">Amount</th>
                <th className="TCol-60">Action</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((FundMoveTran, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td onClick={() => { setcurrentFundMoveTran(FundMoveTran) ; MoblieDev && setSelectedTabId("detail") }}>{FundMoveTran.d_Seq}</td>
                        <td onClick={() => { setcurrentFundMoveTran(FundMoveTran) ; MoblieDev && setSelectedTabId("detail") }}>{FundMoveTran.d_Acct}</td>
                        <td onClick={() => { setcurrentFundMoveTran(FundMoveTran) ; MoblieDev && setSelectedTabId("detail") }}>{FundMoveTran.d_acName1}</td>
                        <td onClick={() => { setcurrentFundMoveTran(FundMoveTran) ; MoblieDev && setSelectedTabId("detail") }}>{FundMoveTran.d_Type}</td>
                        <td onClick={() => { setcurrentFundMoveTran(FundMoveTran) ; MoblieDev && setSelectedTabId("detail") }}>{FundMoveTran.d_Curcy}</td>
                        <td onClick={() => { setcurrentFundMoveTran(FundMoveTran) }}>{FundMoveTran.d_Amt}</td>
                        <td onClick={() => { setcurrentFundMoveTran(FundMoveTran) }}>{FundMoveTran.d_Action}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Fund Movement Entry</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for Fund Movement " labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="SeqNo">Seq No</option>
                                    {/* <option value="acCode">Account No.</option> */}
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "SeqNo"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "SeqNo"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                        <Button className="Col-9-1 Button-LabeledFormGroup" icon="document" onClick={() => { window.open(`/#/fbs/FundMoveTranCheckList`, '_blank') } } >Check List</Button>
                        </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            <FormGroup className="Col-1-2" label="Account Name" labelFor="searchAcName">
                                <InputGroup id="searchAcName" value={searchAcName} onChange={utils.handleStringChange(s => setSearchAcName(s.toUpperCase()))} />
                            </FormGroup>
                            <FormGroup className="Col-3-1" label="Type" labelFor="searchType">
                                <InputGroup id="searchType" value={searchComdy} onChange={utils.handleStringChange(s => setSearchComdy(s.toUpperCase()))} />
                            </FormGroup>
                            {/* <FormGroup className="Col-6-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Fund Movement Entry Log View</H3>
                    <div className="Spacing-V-16" />
                    {logKeyViewRec}
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default FBSFundMoveTranEntryMain